export enum ConfigurationSteps {
    GroundingEntry = 'groundingEntry',
    GroundingTypeSelector = 'groundingTypeSelector',
    GroundingAdvancedBuildingData = 'groundingAdvancedBuildingData',
    Grounder = 'grounder',
    GrounderEquipment = 'grounderEquipment',
    GroundConnection = 'groundConnection',
    FoundationConnectionLug = 'foundationConnectionLug',
    ConnectionLine = 'connectionLine',
    ConnectionPart = 'connectionPart',
    ConnectionLug = 'connectionLug',
    ConnectionLugPart = 'connectionLugPart',
    DGCFixture = 'dgcFixture',
    CorrosionProtectionTape = 'corrosionProtectionTape',
    GeneralEquipment = 'generalEquipment',
    FoundationGroundConnection_CircleGroundConnection = 'foundationGroundConnection_CircleGroundConnection',
    FoundationGroundConnection_CircleGroundConnectionParts = 'foundationGroundConnection_CircleGroundConnectionParts',
    FoundationGroundConnection = 'foundationGroundConnection',
    FoundationGroundConnectionPart = 'foundationGroundConnectionPart',
    SealingSleeveQuestion = 'sealingSleeveQuestion',
    FoundationConnectionParts = 'foundationConnectionParts',
    FoundationConnectionLugPartsForFoundationGrounderWithReinforcedConcrete = 'foundationConnectionLugPartsForFoundationGrounderWithReinforcedConcrete',
    FoundationConnectionLugPartsForFoundationConnectionLug = 'foundationConnectionLugPartsForFoundationConnectionLug',
    GrounderNeededCheck = 'grounderNeededCheck',
    EMVQuestion = 'emvQuestion',
    ProtectiveCaps = 'protectiveCaps',
    ProtectiveCapQuestion = 'protectiveCapQuestion',
    Spacer = 'spacer',
    ReinforcementClamp = 'reinforcementClamp',
    Overview = 'groundingOverview',
    FinishWizard = 'groundingFinishWizard',
    FoundationConnectionLugPartsForFoundationGrounder = 'foundationConnectionLugPartsForFoundationGrounder',
    FoundationConnectionLugPartsForCircleGrounder = 'foundationConnectionLugPartsForCircleGrounder'
}
